
    var doc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"HpoNationalityCountFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"HpoNationalityCountObjectType"}},"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"country"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"count"},"arguments":[],"directives":[]}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"HpoColorCountsFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"HpoColorCountsObjectType"}},"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"red"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"yellow"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"green"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"black"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"uninjured"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"nationalities"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"HpoNationalityCountFragment"},"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"timestamp"},"arguments":[],"directives":[]}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"HpoPatientCountsFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"HpoPatientCountsObjectType"}},"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"registered"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"HpoColorCountsFragment"},"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"registeredOnScene"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"HpoColorCountsFragment"},"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"sum"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"HpoColorCountsFragment"},"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"onScene"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"HpoColorCountsFragment"},"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"beingTransported"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"HpoColorCountsFragment"},"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"inHospital"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"HpoColorCountsFragment"},"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"released"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"HpoColorCountsFragment"},"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"withName"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"HpoColorCountsFragment"},"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"verified"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"HpoColorCountsFragment"},"directives":[]}]}}]}}],"loc":{"start":0,"end":881}};
    doc.loc.source = {"body":"fragment HpoNationalityCountFragment on HpoNationalityCountObjectType{\n    id\n    country\n    count\n}\n\nfragment HpoColorCountsFragment on HpoColorCountsObjectType{\n    id\n    red\n    yellow\n    green\n    black\n    uninjured\n    nationalities{\n        ...HpoNationalityCountFragment\n    }\n    timestamp\n}\n\nfragment HpoPatientCountsFragment on HpoPatientCountsObjectType {\n    id\n    registered{\n        ...HpoColorCountsFragment\n    }\n    registeredOnScene{\n        ...HpoColorCountsFragment\n    }\n    sum{\n        ...HpoColorCountsFragment\n    }\n    onScene{\n        ...HpoColorCountsFragment\n    }\n    beingTransported{\n        ...HpoColorCountsFragment\n    }\n    inHospital{\n        ...HpoColorCountsFragment\n    }\n    released{\n        ...HpoColorCountsFragment\n    }\n    withName{\n        ...HpoColorCountsFragment\n    }\n    verified{\n        ...HpoColorCountsFragment\n    }\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }
    
    module.exports = doc;
    
        module.exports["HpoNationalityCountFragment"] = oneQuery(doc, "HpoNationalityCountFragment");
        
        module.exports["HpoColorCountsFragment"] = oneQuery(doc, "HpoColorCountsFragment");
        
        module.exports["HpoPatientCountsFragment"] = oneQuery(doc, "HpoPatientCountsFragment");
        
